import { Storage } from '@jane/shared/util';

export const resetSignInPrompt = () => Storage.remove('kioskSignInPrompt');
